'use client';
// import { TRPCError } from '@repo/api/validations/trpc-error';
import React, { ErrorInfo } from 'react';
import { clearCookies } from './server/actions/user-action';
/**
 * @ref https://legacy.reactjs.org/docs/error-boundaries.html#introducing-error-boundaries
 */
class ErrorBoundary extends React.Component<{ children: React.ReactNode; fallback: React.ReactNode }> {
  state = { hasError: false };
  constructor(props: { children: React.ReactNode; fallback: React.ReactNode } | Readonly<{ children: React.ReactNode; fallback: React.ReactNode }>) {
    super(props);
  }

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Example "componentStack":
    //   in ComponentThatThrows (created by App)
    //   in ErrorBoundary (created by App)
    //   in div (created by App)
    //   in App
    // console.log(error, info.componentStack);
    // console.log('error instanceof :>> ', error );

    //     digest
    // :
    // "980489824"
    // message
    // :
    // "\nInvalid `prisma.user.create()` invocation:\n\n\nUnique constraint failed on the fields: (`username`)"
    // stack
    // :
    // "TRPCClientError: \nInvalid `prisma.user.create()` invocation:\n\n\nUnique constraint failed on the fields: (`username`)\n    at TRPCClientError.from (webpack-internal:///(action-browser)/../../node_modules/.pnpm/@trpc+client@10.45.1_@trpc+server@10.45.1/node_modules/@trpc/client/dist/TRPCClientError-38f9a32a.mjs:43:16)\n    at eval (webpack-internal:///(action-browser)/../../packages/api/src/trpc/server.ts:56:98)"

    // alert(error.message.split('\n\n\n')[1] ?? error.message);
    // const stack = JSON?.parse( as string)
    // this.setState({ polling: this.state.polling * 2 })
    // this.setState((state)=>({count: state.polling + 1}))

    sessionStorage.removeItem('reloadCount');

    if (error.message === 'UNAUTHORIZED' || error.message === 'FORBIDDEN' || error.name === 'Error') {
      process.env.NODE_ENV === 'production' ? clearCookies() : null;
      setTimeout(() => {
        this.handleOnReloadEvent(error);
      }, 1000);
    }

    this.handleOnReloadEvent(error);
  }

  handleOnReloadEvent(error: Error) {
    if (this.state.hasError) {
      const reloadCount = sessionStorage.getItem('reloadCount');
      if (Number(reloadCount) < 1) {
        this.handleErrorToast(error.message.split('\n\n\n')[1] ?? error.message);

        sessionStorage.setItem('reloadCount', String(Number(reloadCount) + 1));
        process.env.NODE_ENV === 'production' ? window.location.reload() : null;
      } else {
        sessionStorage.removeItem('reloadCount');
      }
    }
  }

  handleErrorToast(message: string) {
    // window.location.
    //TODO: add Toast here to the error messages!
    alert(message);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }

    return this.props.children;
  }
}

export { ErrorBoundary };
